
jQuery(document).ready(function () {
  if (window.productGroupingOptionsSettings) {
    const settings = window.productGroupingOptionsSettings;

    settings.blocks.forEach((block) => {
      const { option_name, sorted_list } = block;
      $select_option = jQuery('.pdp-group-js[data-name="' + option_name + '"]');

      if ($select_option.length > 0) {
        $select_option.find('li').each(function () {
          let $this = jQuery(this);
          sorted_list.forEach(function (el, index) {
            el = el.trim();
            if ($this.data('value') == el || $this.data('feature') == el) {
              $this.addClass('v-order-' + index);
            }
          });
        });
      }
    });
  }
});
